/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  class GiftPopupButton extends HTMLElement {
    constructor() {
      super();
      this.attachShadow({ mode: 'open' });
      this.loading = false;
      this.hiddenUtilKey = 'gift-popup-closed-until';
    }

    shouldDisplayPopup() {
      const closedUntil = localStorage.getItem(this.hiddenUtilKey);
      if (!closedUntil) return true;
      const now = new Date().getTime();
      return now > parseInt(closedUntil);
    }
    async connectedCallback() {
      this.watchFetchEvents();
      await this.render();
      this.bindCartEvents();
      if (this.shouldDisplayPopup()) {
        this.style.display = 'block';
      }
    }

    watchFetchEvents() {
      const originalFetch = window.fetch;
      window.fetch = async function(resource, config) {
        const isCartUpdate = typeof resource === 'string' && (
          resource.includes('/cart/add') || resource.includes('/cart/update') || resource.includes('/cart/change')
        );
        const isFromFreeGift = typeof resource === 'string' && resource.includes('free-gift');

        const response = await originalFetch(resource, config);

        if (response.ok && isCartUpdate && !isFromFreeGift) {
          document.dispatchEvent(new CustomEvent('cart:after-update'));
        }
        return response;
      };
    }

    bindCartEvents() {
      document.addEventListener('cart:after-update', async evt => {
        await this.judgeCart();
        await this.updateFreeGifts();
      });

      document.addEventListener('add:free-gift', async evt => {
        const variantId = evt.detail.variantId;
        await this.updateFreeGift(variantId);
        await this.updateFreeGifts();
      });
      function preventScrollThrough(el) {
        if (!el) return;

        el.addEventListener('touchstart', onTouchStart, { passive: false });
        el.addEventListener('touchmove', onTouchMove, { passive: false });

        let startY = 0;

        function onTouchStart(e) {
          startY = e.touches[0].clientY;
        }

        function onTouchMove(e) {
          const currentY = e.touches[0].clientY;
          const deltaY = currentY - startY;

          const scrollTop = el.scrollTop;
          const scrollHeight = el.scrollHeight;
          const offsetHeight = el.offsetHeight;

          const isAtTop = scrollTop === 0;
          const isAtBottom = scrollTop + offsetHeight >= scrollHeight - 1;

          // 向下滑，且已经在顶部
          if (deltaY > 0 && isAtTop) {
            e.preventDefault();
            return;
          }

          // 向上滑，且已经在底部
          if (deltaY < 0 && isAtBottom) {
            e.preventDefault();
            return;
          }

          e.stopPropagation();
          // 否则允许滑动（在内部正常滚动）
          // 注意：必须 passive: false 才能 preventDefault
        }
      }

      const popup = this.shadowRoot.querySelector('.popup');
      preventScrollThrough(popup);
  
      const closeBtn = this.shadowRoot.querySelector('div.icon-closex');
      if (closeBtn) {
        closeBtn.addEventListener('click', () => {
          const oneDayInMs = 24 * 60 * 60 * 1000;
          const tomorrow = new Date().getTime() + oneDayInMs;
          localStorage.setItem(this.hiddenUtilKey, tomorrow);
          this.style.display = 'none'; 
        });
      }

      this.style.display = 'block';
      var that = this;
      (async () => {
        async function init()  {
          await that.judgeCart();
          await that.updateFreeGifts();
        }

        if (document.readyState === 'complete' || document.readyState === 'interactive') {
          await init(); // 页面已加载
        } else {
          document.addEventListener('DOMContentLoaded', async () => {
            await init();
          });
        }
      })();
    }

    

    async judgeCart() {
      const cart = await fetch(`${theme.routes.cart_url}.js`).then(res => res.json());
      const cartItemIds = cart.items.map(item => item.id);
      const updates = {};
      // 自动移除不符合条件的赠品
      const freeGiftItems = Array.from(this.shadowRoot.querySelectorAll('.free-item'));
      Array.from(freeGiftItems).forEach(item => {
        const variantIds = item.dataset.variantIds.split(',').filter(id => cartItemIds.includes(parseInt(id)));
        const threshold = parseInt(item.dataset.threshold);
        if (cart.total_price < threshold) {
          variantIds.forEach(id => {
            updates[id] = 0;
          });
        }
      });
      if (Object.keys(updates).length > 0) {
        await fetch(`${theme.routes.cart_update_url}?source=free-gift`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            updates
          })
        }).then(r => r.json());
        document.dispatchEvent(new CustomEvent('cart:drawer:update'));
      }
    }

    async updateFreeGift(variantId) {
      const cart = await fetch(`${theme.routes.cart_url}.js`).then(res => res.json());
      const freeGiftItems = Array.from(this.shadowRoot.querySelectorAll('.free-item'));
      const cartItemIds = cart.items.map(item => item.id);
      const add = {}, updates = {};
      // 先查询再购物车中的免费商品,移除并替换成新的
      Array.from(freeGiftItems).forEach(item => {
        item.dataset.variantIds.split(',')
          .filter(id => cartItemIds.includes(parseInt(id)))
          .forEach(id => {
            updates[id] = 0;
          });
      });
      if (!updates.hasOwnProperty(variantId)) {
        add[variantId] = 1;
      }

      if (Object.keys(updates).length > 0) {
        const updateResponse = await fetch(`${theme.routes.cart_update_url}?source=free-gift`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            updates
          })
        });
        updateResponse.json();
      }
      if (Object.keys(add).length > 0) {
        const addResponse = await fetch(`${theme.routes.cart_add_url}.js?source=free-gift`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: Object.keys(add).map(key => ({
              id: key,
              quantity: add[key]
            }))
          })
        });
        addResponse.json();
      }
      document.dispatchEvent(new CustomEvent('cart:drawer:update'));
    }

    async render() {
      await this.updateFreeGifts();
    }

    async updateFreeGifts() {
      const freeContainer = this.shadowRoot.querySelector('.free-container');
      if (freeContainer) {
        freeContainer.classList.add('is-loading');
      }
      try {
        const response = await fetch(`${theme.routes.root}?section_id=free-gift`)
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const freeGiftSection = doc.querySelector('.shopify-section');
        if (!this.classList.contains('gift-loaded')) {
           this.shadowRoot.innerHTML = freeGiftSection.innerHTML;
           this.classList.add('gift-loaded');
           this.bindPopupEvents();
        } else {
          this.shadowRoot.querySelector('.popup').innerHTML = doc.querySelector('.popup').innerHTML;
        }
        this.bindItemEvents();
      } finally {
        if (freeContainer) {
          freeContainer.classList.remove('is-loading');
        }
      }
    }

    bindPopupEvents() {
      const triggerBtn = this.shadowRoot.querySelector('.trigger-button');
      const popup = this.shadowRoot.querySelector('.popup');

      const toggleAction = () => {
        triggerBtn.classList.toggle('active');
        popup.classList.toggle('active');
      };

      triggerBtn.addEventListener('click', toggleAction);
      this.addEventListener('toggle:popup:hidden', () => {
        triggerBtn.classList.remove('active');
        popup.classList.remove('active');
      });
    }

    bindItemEvents() {
      const items = this.shadowRoot.querySelectorAll('.free-item');
      const freeContainer = this.shadowRoot.querySelector('.free-container');
      Array.from(items).forEach(item => {
        const seletor = item.querySelector('select')
        seletor.addEventListener('change', evt => {
          // 找到对应的option，然后把option上面的data-image属性值设置给图片.free-item__image img
          const option = evt.target.options[evt.target.selectedIndex];
          const image = item.querySelector('.free-item__image img');
          image.src = option.dataset.image;
        });

        const addActionNode = item.querySelector('.free-item__button');
        addActionNode.addEventListener('click', async () => {
          if (!this.loading) {
            freeContainer.classList.add('is-loading');
            const variantId = seletor.value;
            await this.updateFreeGift(variantId);
            await this.updateFreeGifts();
            freeContainer.classList.remove('is-loading');
          }
          this.loading = false;
          this.dispatchEvent(new CustomEvent('toggle:popup:hidden'));
        });
      });
    }
  }

  customElements.define('gift-popup-button', GiftPopupButton);
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
